import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: 'app-add-control-item-dialog',
  templateUrl: './addControlItemDialog.component.html'
})
export class AddControlItemDialogComponent {
  controlItemForm: FormGroup;
  categoryName: string;

  constructor(
    private _formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AddControlItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { category: string }
  ) {
    this.categoryName = data.category;
    this.controlItemForm = this._formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.controlItemForm.valid) {
      this.dialogRef.close({
        category: this.categoryName,
        title: this.controlItemForm.value.title,
        description: this.controlItemForm.value.description
      });
    }
  }
}
